import type { ReactNode } from 'react';
import { PaperPlaneTiltIcon, ShieldIcon } from '@phosphor-icons/react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';

/*
 * O pé da lista de resultados quando a lista não resolveu: a PORTA para o
 * pedido offline à equipe VOLL — o "concierge" do legado (`_HotelConciergeBanner`
 * e `FlightOfflineCard` do voll_modules_library). Não coleta nada: o perfil já
 * existe, e quem pede detalhes (motivo, restrições, observação) é o checkout do
 * pedido, que o host abre ao clicar. Depois de enviado, o pedido NÃO volta para
 * cá: o host troca a lista pela tela "Solicitação enviada" (a mesma do checkout
 * online, no web-chat) — o pedido é terminal para a busca, como a reserva.
 * Superfície `muted`, não vidro; CTA em ink — pedir à equipe é MEIO de ciclo,
 * não a compra. Todo texto vem por props (regra do kit).
 */

export type ResultsOfflineRequestCopy = {
  /** "Precisa de algo que não está aqui?" e a frase que explica quem busca. */
  readonly offerTitle: string;
  readonly offerBody: string;
  /** "Pedir à equipe VOLL" — abre o checkout do pedido no host. */
  readonly offerAction: string;
};

export type ResultsOfflineRequestProps = {
  readonly copy: ResultsOfflineRequestCopy;
  /** A superfície está travada (checkout aberto, read-only): sem pedir. */
  readonly disabled?: boolean;
  readonly onRequest: () => void;
};

export function ResultsOfflineRequest({
  copy,
  disabled = false,
  onRequest,
}: ResultsOfflineRequestProps): ReactNode {
  return (
    <section
      className="border-border bg-muted/60 grid gap-3 rounded-xl border p-3.5"
      aria-label={copy.offerTitle}
    >
      <div className="flex items-start gap-2.5">
        <span className="bg-foreground grid size-8 shrink-0 place-items-center rounded-full text-white">
          <ShieldIcon className="size-4" aria-hidden="true" />
        </span>
        <span className="grid min-w-0 gap-0.5">
          <span className="text-ui font-medium">{copy.offerTitle}</span>
          <span className="text-caption text-muted-foreground">{copy.offerBody}</span>
        </span>
      </div>
      {/* Encostado na direita: o pé da lista é um convite, e a ação de convite
          mora na ponta oposta ao texto que a justifica (`justify-self-end`
          porque o pai é grid). */}
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="w-fit justify-self-end"
        disabled={disabled}
        onClick={onRequest}
      >
        <PaperPlaneTiltIcon aria-hidden="true" />
        {copy.offerAction}
      </Button>
    </section>
  );
}
